// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'
import { valueFromKm } from 'helpers/unitConversion'

// p is the interferenceParameter object

const parseInterferenceParameter = (p, unitType, propagationModels) => {
  const {
    interferenceProjectParameterId,
    objective: { objectiveId },
  } = p

  // TODO NEXT - sort out what to do here
  // - AFS parameters data has band at top level of the entity.
  // - default parameters has it as a band entity
  // - should API make this consistent?
  const bandId = p.band?.bandId || p.bandId

  // This is a static value which is displayed in the UI.
  // The API does not provide this value in the parameters payload.
  const keyholeAngle = '-/+ 5°'

  // this field is handled by a checkbox group in the form.
  const analysisTypes = p.analysisTypes.map(t => castToString(t.analysisTypeId))

  const frequencyWindow = castToString(p.frequencyWindow)
  const marginToObjective = castToString(p.marginToObjective)

  // propagationModelId is not nullable
  // TODO NEXT - sort out what to do here
  // - AFS parameters data has propagationModel at top level of the entity.
  // - default parameters has it as a propagationModel entity
  // - should API make this consistent?
  const propagationModel = (
    p.propagationModel
      ? p.propagationModel
      : propagationModels.find(d => d.get('propagationModelId') === p.propagationModelId).toJS()
  )

  const keyholeRadiusUnit = unitType
  const keyholeRadius = castToString(
    valueFromKm(p.keyholeRadiusKm, unitType)
  )

  const minimumProfileDistanceUnit = unitType
  const minimumProfileDistance = castToString(
    valueFromKm(p.minimumProfileDistanceKm, unitType)
  )

  const minimumRadiusUnit = unitType
  const minimumRadius = castToString(
    valueFromKm(p.minimumRadiusKm, unitType)
  )

  return {
    analysisTypes,
    bandId,
    frequencyWindow,
    interferenceProjectParameterId,
    keyholeAngle,
    keyholeRadius,
    keyholeRadiusUnit,
    marginToObjective,
    minimumProfileDistance,
    minimumProfileDistanceUnit,
    minimumRadius,
    minimumRadiusUnit,
    objectiveId,
    propagationModel,
  }
}

export default parseInterferenceParameter
